import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-errorv3',
  templateUrl: './errorv3.component.html',
  styleUrls: ['./errorv3.component.scss']
})
export class Errorv3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
